export async function pictureVerification() {
  const aid = global.APP_CONFIG.aid
  return new Promise((rs, rj) => {
    const captcha = new window.TencentCaptcha(aid, (res) => {
      res.ticket ? rs(res) : rj()
    })
    captcha.show()
  })
}
export function remoteLoad(url) {
  return new Promise((rs, rj) => {
    // 防止重复引入
    if (window[url]) {
      rs()
    }
    else {
      const script = document.createElement('script')
      script.src = url
      document.body.append(script)
      script.onload = () => {
        window[url] = script
        rs()
      }
      script.onerror = () => {
        document.body.removeChild(script)
        rj()
      }
    }
  })
}
